import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as animationHelper from "../../../helpers/animationHelper";

class ScenarioBiteProgress extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            percentageComplete: this.props.percentageComplete,
            allowUpdate: false,
            className: "",
            this_module_is_label: appHelper.getLocaleString("this_module_is_label"),
            complete_label: appHelper.getLocaleString("complete_label"),
        };
        this.updateProgress = this.updateProgress.bind(this);
        this.onUpdateComplete = this.onUpdateComplete.bind(this);

        this.progressMeter = React.createRef();
    }

    componentDidMount() {
        this.updateProgress();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.percentageComplete !== nextProps.percentageComplete){
            this.setState({
                percentageComplete: nextProps.percentageComplete,
                allowUpdate: true
            });
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                this_module_is_label: appHelper.getLocaleString("this_module_is_label"),
                complete_label: appHelper.getLocaleString("complete_label"),
            });
        }
    }

    componentDidUpdate(){
        if(this.state.allowUpdate){
            this.updateProgress();
        }
    }
    updateProgress() {
        this.setState({allowUpdate: false});
        let progressMeter = this.progressMeter.current;

        let params = {
            ele: progressMeter,
            duration: objectConstants.PROGRESS_UPDATE_DURATION,
            width: `${this.state.percentageComplete}%`,
            delay: 0,
            callback: this.onUpdateComplete
        };

        animationHelper.animateWidth(params);
    }

    onUpdateComplete(){
        if(this.state.percentageComplete === 100){
            this.setState({
                className: "complete"
            });
        }
    }

    render() {
        return (
            <div className="bite-progress-bar" role="presentation" id="scenarioBiteProgress">
                <div className={`progress-meter ${this.state.className}`} ref={this.progressMeter} role="progressbar" aria-valuenow={this.state.percentageComplete} aria-valuemin="0" aria-valuemax="100"><span className="hidden-el">{this.state.this_module_is_label} {this.state.percentageComplete}% {this.state.complete_label}.</span></div>
            </div>

        );
    }
}

ScenarioBiteProgress.propTypes = {
    bite: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    percentageComplete: PropTypes.number.isRequired,
    actions: PropTypes.object.isRequired
};

ScenarioBiteProgress.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let userBite = appHelper.getArrayObjectByKey(state.userData.bites, "bite_id", ownProps.bite.bite_id);
    let lang = state.userData.lang;
    return {
        lang:lang,
        percentageComplete: userBite.percentageComplete
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ScenarioBiteProgress);



/** WEBPACK FOOTER **
 ** ./src/components/bites/ScenarioBite/ScenarioBiteProgress.js
 **/